import { FormWithRedux } from '../../FormWithRedux';
import { ACCBISTOrientationCheck2Form } from './ACCBIST-OrientationCheck2Form';
import { ACCBISTRecollectionCheck2Form } from './ACCBIST-RecollectionCheck2Form';
import { ACCBISTRecollectionFailureCheck2Form } from './ACCBIST-RecollectionFailureCheck2Form';
import { ACCBISTNeuroObsForm } from './ACCBIST-NeuroObsForm';

import moment from 'moment';

import { FormValidationError } from '../../../waferJS/Form/Validation/FormValidationError';
import { FormValidation } from '../../../waferJS/Form/Validation/FormValidation';

export class ACCBISTAWPTA2Form extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('awptaCheck2Subform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'orientationCheck2Subform':
                return new ACCBISTOrientationCheck2Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'recollectionCheck2Subform':
                return new ACCBISTRecollectionCheck2Form(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'recollectionFailureCheck2Subform':
                return new ACCBISTRecollectionFailureCheck2Form(this, this.actionUpdater, this,this.dependentValuesUpdater, this.calculationsUpdater);
            case 'gcsSubform':
                return new ACCBISTNeuroObsForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
    
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        return true;
    }

    getValueType(identifier) {
        return 'date';
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        if (identifier == 'awptaCheck2DateTime') {
            let self = this;

            let timeConflict = new FormValidation('AbnormalitiesPresentConflict', function () {
                let value = self.getValue(identifier);
                let check1Value = self.getValue('awptaCheck1DateTime');
                if (value != null && value!= undefined && check1Value != null && check1Value != undefined) {
                    let firstCheck = moment(new Date(check1Value));
                    let secondCheck = moment(new Date(value));
                    var duration = moment.duration(secondCheck.diff(firstCheck));
                    var hours = duration.asHours();

                    if (hours < 1) {
                        return [new FormValidationError(FormValidationError.FormErrorType.warning, 'Second check should be at least 1 hour after the first.')];
                    }
                    else {
                        return [];
                    }
                
                }
                else {
                    return [];
                }
            });
            return [timeConflict];
        }
        
        return [];
    }

    detailForIdentifier(prefix, value) {
        if(value.identifier == 'gcsSubform') {
            return null;
        }
        
        return super.detailForIdentifier(prefix, value);
    }

    htmlForIdentifier(prefix, value) {
        if(value.identifier == 'gcsSubform') {
            return null;
        }
        else {
            return super.htmlForIdentifier(prefix, value);
        }
    }

    shouldShowInSidebar() {
        if(this.getValue('awptaCheck1DateTime') != null && this.getValue('awptaCheck1DateTime') != undefined) {
            return true;
        }

        return false;
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-AWPTA2Form.js